import { alpha, useTheme } from "@mui/material";
import shortid from "shortid";
import Chip from "../chip/chip.component";
import Grid from "../grid/grid.component";

const ListStatus = ({
  selectedStatus,
  setSelectedStatus,
  listaStatus,
  handleChangeStatus,
}) => {

  const theme = useTheme();

  const renderLabel = (status) => {
    if (status.status) {
      const textoMinusculo = status.status.toLowerCase();
      return textoMinusculo.charAt(0).toUpperCase()
        + textoMinusculo.slice(1);
    } else {
      return status.label;
    }
  }

  const validateStatus = (status) => {
    const texto = status.nome || status.status;
    return selectedStatus.find((item) => item.nome === texto);
  };

  const handleClick = (status) => {
    const texto = status.nome || status.status;
    const newStatus = validateStatus(status)
      ? selectedStatus.filter((item) => item.nome !== texto)
      : [...selectedStatus, { id: status.id, nome: texto }];

    setSelectedStatus(newStatus);
    handleChangeStatus(newStatus);
  };

  return (
    <Grid container spacing={2}>
      {listaStatus.map((status) => {
        const isSelected = validateStatus(status);
        const backgroundColor = isSelected
          ? status.cor
          : alpha(status.cor, 0.08);

        const textColor = isSelected 
          ? theme.palette.getContrastText(backgroundColor)
          : "#000";
        
        const textHoverColor = isSelected
          ? "#000" 
          : theme.palette.getContrastText(backgroundColor);

        return (
          <Chip
            className="d-flex my-1 mx-2 p-1"
            key={shortid.generate()}
            icon={<i className="ph-fill ph-circle"></i>}
            label={renderLabel(status)}
            sx={{
              backgroundColor,
              color: textColor,
              "&:hover": {
                backgroundColor: isSelected
                  ? alpha(status.cor, 0.08)
                  : alpha(status.cor, 0.75),
                color: textHoverColor,
                transform: "scale(1.05)",
                transition: "all 0.4s ease-in-out",
              },
              ".MuiChip-icon": {
                color: isSelected
                  ? "#fff"
                  : status.cor,
              },
              "&:hover .MuiChip-icon": {
                color: isSelected
                  ? status.cor
                  : "#fff",
                transition: "all 0.4s ease-in-out",
              },
            }}
            onClick={() => handleClick(status)}
          /> 
        )}
      )}
    </Grid>
  );
};

export default ListStatus;
